import type { IsoWeekday, ReportEmailDeliveryFrequency } from "../client-messages";
import { reportUpdateTimeLabel, type ReportUpdateTimeContext } from "./report-update-time";

const WEEKDAY_NAMES: Readonly<Record<IsoWeekday, string>> = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
};

/**
 * The "Active" line for a saved report email delivery, in the viewer's time,
 * e.g. "Weekly, every Monday, after the report updates at 6:00 am AEDT".
 */
export function reportEmailDeliverySummary(
  saved: ReportEmailDeliveryFrequency,
  context: ReportUpdateTimeContext,
): string {
  return saved.frequency === "daily" ?
      `Daily, after the report updates at ${reportUpdateTimeLabel(context)}`
    : `Weekly, every ${WEEKDAY_NAMES[saved.weekday]}, after the report updates at ${reportUpdateTimeLabel({ ...context, weekday: saved.weekday })}`;
}
